(function () {
  const main = document.getElementById("buttr-main");
  document.querySelectorAll("[data-full]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!main) return;
      main.src = thumb.dataset.full;
      document.querySelectorAll("[data-full]").forEach((el) => el.classList.remove("is-active"));
      thumb.classList.add("is-active");
    });
  });

  function selectPack(input) {
    const available = input.dataset.available === "true";
    document.querySelectorAll(".js-variant-id").forEach((field) => {
      field.value = input.value;
    });
    document.querySelectorAll(".js-price").forEach((el) => {
      el.textContent = input.dataset.price;
    });
    document.querySelectorAll(".js-compare").forEach((el) => {
      el.textContent = input.dataset.compare;
    });
    document.querySelectorAll(".js-save").forEach((el) => {
      el.textContent = input.dataset.save ? "Save " + input.dataset.save : "";
    });
    document.querySelectorAll(".js-ship-note").forEach((el) => {
      const discount =
        "Use BUTTR10 for 10% off · pay <span class=\"js-discount-price\">" +
        (input.dataset.discounted || "") +
        "</span> after code · ";
      el.innerHTML =
        input.dataset.title === "1 Stick"
          ? discount + "$4.95 shipping · free on 2+ sticks"
          : discount + "<strong>Free shipping</strong>";
    });
    document.querySelectorAll(".js-atc").forEach((btn) => {
      btn.disabled = !available;
      btn.textContent = available
        ? "Add " + input.dataset.title.toLowerCase() + " to cart — " + input.dataset.price
        : "Sold out";
    });
    document.querySelectorAll(".js-sticky-price").forEach((el) => {
      el.textContent = input.dataset.title + " · " + input.dataset.price + " before discount";
    });
    document.querySelectorAll(".pack").forEach((pack) => pack.classList.remove("is-selected"));
    input.closest(".pack")?.classList.add("is-selected");
    document.querySelectorAll(".js-pack").forEach((other) => {
      if (other.value === input.value) other.checked = true;
    });
  }

  document.querySelectorAll(".js-pack").forEach((input) => {
    input.addEventListener("change", () => selectPack(input));
  });

  const sticky = document.querySelector(".sticky-atc");
  if (sticky) {
    const onScroll = () => {
      sticky.classList.toggle("is-visible", window.scrollY > 640);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    sticky.querySelector("button")?.addEventListener("click", () => {
      document.querySelector(".offer-form")?.scrollIntoView({ behavior: "smooth", block: "center" });
      document.querySelector(".offer-form .js-atc")?.click();
    });
  }
})();
